import clsx from 'clsx';
import Button from 'components/Button';
import {FC} from 'react';
import {t} from 'ttag';
import {AddressFormat} from 'types/address';

type ChangeAddressFormatProps = {
    format?: AddressFormat;
    onClick: () => void;
    selected: boolean;
};

const ChangeAddressFormat: FC<ChangeAddressFormatProps> = ({
    format,
    onClick,
    selected,
}) => (
    <div
        className={clsx(
            'col-span-12 mt-2 flex border-t p-2',
            selected ? 'border-blue-100 bg-blue-50' : 'border-grey-200',
        )}
    >
        <Button
            className="flex-1 border-none text-left text-sm text-green-700"
            kind="custom"
            onClick={onClick}
        >
            {format === 'jp_default'
                ? t`Change to Western address format`
                : t`Change to Japanese address format`}
        </Button>
    </div>
);

export default ChangeAddressFormat;
